import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { memo } from 'react';
import { useNavigate } from 'react-router-dom';
import { StyledButton } from '../ui';

/**
 * Header component for EBooks page with back navigation
 *
 * @returns {React.ReactElement} Header component with back button
 */
const EBooksPageHeader = memo(function EBooksPageHeader() {
  const navigate = useNavigate();

  return (
    <StyledButton
      variant="link"
      startIcon={<ArrowBackIcon />}
      onClick={() => navigate('/')}
      sx={{ mb: 4 }}
    >
      Back to Home
    </StyledButton>
  );
});

export default EBooksPageHeader;
